import config from "config";
import { APICore } from "helpers/api/apiCore";
import { CreateCrilicReportRequest } from "./types";

const api = new APICore();
function createCrilicReportApi(apiData: CreateCrilicReportRequest) {
    let backendApiUrl = `${config.BACKEND_BASE_URL}/report/crilic-report`;
    return api.create(`${backendApiUrl}`, apiData.payload);
}

export { createCrilicReportApi };
